
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TogglePanel from "../../components/TogglePanel.vue";
import IconButtonShuffle from "../../components/IconButtonShuffle.vue";
import { globalStore, configStore } from "@/store/store";
import BrandTypographyPicker from "./BrandTypographyPicker.vue";
import { Font } from "@/types/fonts";
import {
  updateGlobalTypography,
  updateGlobalTypographyRatio,
  randomTypographyFontPair
} from "@/lib/singularity/brand/typography";
import BrandToggleFontSizes from "./BrandToggleFontSizes.vue";

@Component({
  components: {
    TogglePanel,
    IconButtonShuffle,
    BrandTypographyPicker,
    BrandToggleFontSizes
  }
})
export default class BrandManageTypography extends Vue {
  get globalTypography() {
    return globalStore.globalSettings.settings.typography;
  }

  get headingFont() {
    return configStore.fonts.filter(
      (font: Font) => font.slug === this.globalTypography.heading_font
    )[0];
  }

  get bodyFont() {
    return configStore.fonts.filter(
      (font: Font) => font.slug === this.globalTypography.body_font
    )[0];
  }

  shuffle() {
    const { body_font, heading_font } = randomTypographyFontPair();
    updateGlobalTypography("body_font", body_font);
    updateGlobalTypography("heading_font", heading_font);
  }

  updateFontRatio(ratio: number) {
    updateGlobalTypographyRatio(ratio);
  }

  updateFont(type: "heading_font" | "body_font", slug: Font["slug"]) {
    updateGlobalTypography(type, slug);
  }
}
